export { default } from './createMediaQuery'
export * from './createMediaQuery'
